import httpClient from '@/shared/http-auth-data-client';

const getAllRoles = () => httpClient.get('/roles');
const getApplicationPages = () => httpClient.get('/ApplicationPages?$expand=PagesInRoles');
const getPagesInRoles = () => httpClient.get('/PagesInRoles');
const patchPagesInRoles = (data) => httpClient.patch('/ApplicationPages', data);

export {
  // eslint-disable-next-line import/prefer-default-export
  getAllRoles,
  getApplicationPages,
  getPagesInRoles,
  patchPagesInRoles,
};
